var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 274.84 298.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-26,.cls-42{opacity:0.2;}.cls-3{opacity:0;}.cls-4{opacity:0.09;}.cls-5{opacity:0.18;}.cls-6{opacity:0.27;}.cls-7{opacity:0.36;}.cls-8{opacity:0.45;}.cls-9{opacity:0.55;}.cls-10{opacity:0.64;}.cls-11{opacity:0.73;}.cls-12{opacity:0.82;}.cls-13{opacity:0.91;}.cls-14{fill:url(#linear-gradient);}.cls-15{fill:url(#linear-gradient-2);}.cls-16{fill:url(#linear-gradient-3);}.cls-17{fill:#fff;}.cls-18,.cls-38,.cls-47,.cls-50,.cls-51{mix-blend-mode:color-dodge;}.cls-18{fill:url(#New_Gradient_Swatch_copy);}.cls-19{fill:url(#linear-gradient-4);}.cls-20,.cls-25,.cls-41,.cls-42,.cls-53{mix-blend-mode:screen;}.cls-20,.cls-52{opacity:0.3;}.cls-20{fill:url(#linear-gradient-5);}.cls-21{fill:url(#linear-gradient-6);}.cls-22{fill:url(#New_Gradient_Swatch_copy_26);}.cls-23{fill:#bcbec0;}.cls-23,.cls-26,.cls-52{mix-blend-mode:multiply;}.cls-24{fill:url(#linear-gradient-7);}.cls-25{fill:url(#Radial_Gradient_1);}.cls-26{fill:#231f20;}.cls-27{fill:url(#linear-gradient-8);}.cls-28{fill:#b086cc;}.cls-29{fill:url(#New_Gradient_Swatch_copy_7);}.cls-30{fill:url(#New_Gradient_Swatch_copy_7-2);}.cls-31{fill:url(#New_Gradient_Swatch_copy_7-3);}.cls-32{fill:url(#New_Gradient_Swatch_copy_7-4);}.cls-33{fill:url(#New_Gradient_Swatch_copy_7-5);}.cls-34{fill:url(#linear-gradient-9);}.cls-35{fill:url(#linear-gradient-10);}.cls-36{fill:#70789c;}.cls-37{fill:url(#linear-gradient-11);}.cls-38{fill:url(#radial-gradient);}.cls-39{fill:url(#radial-gradient-2);}.cls-40{fill:url(#linear-gradient-12);}.cls-41{fill:url(#radial-gradient-3);}.cls-42{fill:url(#radial-gradient-4);}.cls-43{fill:url(#linear-gradient-13);}.cls-44{fill:url(#linear-gradient-14);}.cls-45{fill:url(#linear-gradient-15);}.cls-46{fill:url(#linear-gradient-16);}.cls-47{fill:url(#radial-gradient-5);}.cls-48{fill:url(#linear-gradient-17);}.cls-49{fill:url(#linear-gradient-18);}.cls-50{fill:url(#radial-gradient-6);}.cls-51{fill:url(#radial-gradient-7);}.cls-52{fill:url(#radial-gradient-8);}.cls-53{fill:url(#radial-gradient-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 336.4,
    y1: 274.98,
    x2: 605.5,
    y2: 274.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a17bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a783bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b290c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c4a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#cdb3dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dbc8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#efe7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ece0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ddc8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d4b9e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b395d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9c7dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8e6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 330.68,
    y1: 267.94,
    x2: 589.56,
    y2: 267.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f054a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 333.57,
    y1: 267.94,
    x2: 586.66,
    y2: 267.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy",
    cx: 1401.62,
    cy: -1939.58,
    r: 36.18,
    gradientTransform: "matrix(1, 0, 0, 0.59, -986.41, 1371.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -336.02,
    y1: 440.71,
    x2: -454.01,
    y2: 351.51,
    gradientTransform: "matrix(0.87, 0.5, -1.5, 0.29, 1411.21, 339.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 440.63,
    y1: 208.45,
    x2: 506.73,
    y2: 312.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a17bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a883c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b490cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c5a3dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#dbbbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b595dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9d7dcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8e6ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 5317.16,
    y1: 22.71,
    x2: 5047.84,
    y2: 256.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 5661.35, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 1562.94,
    y1: 268.5,
    x2: 1434.43,
    y2: 69.27,
    gradientTransform: "translate(-985.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1613.16,
    y1: 284.07,
    x2: 1480.77,
    y2: 72.52,
    gradientTransform: "translate(-985.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a17bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a783bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b290c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c4a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#cdb3dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dbc8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#efe7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ece0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ddc8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d4b9e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#cfb2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#be9ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b48bcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 1575.39,
    cy: 154.1,
    r: 22.5,
    gradientTransform: "translate(-985.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 405.19,
    y1: 331.15,
    x2: 522.69,
    y2: 130.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ecedee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7",
    x1: 511.68,
    y1: 138.57,
    x2: 468.68,
    y2: 117.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-2",
    x1: 511.48,
    y1: 138.96,
    x2: 468.48,
    y2: 117.96,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-3",
    x1: 511.21,
    y1: 139.52,
    x2: 468.21,
    y2: 118.52,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-4",
    x1: 511.05,
    y1: 139.85,
    x2: 468.05,
    y2: 118.85,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-5",
    x1: 510.16,
    y1: 141.67,
    x2: 467.16,
    y2: 120.67,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 473.22,
    y1: 157.31,
    x2: 550.24,
    y2: 157.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2160.32,
    y1: 2455.74,
    x2: -2068.97,
    y2: 2455.74,
    gradientTransform: "matrix(0.87, 0.5, -1, 0.58, 4753.61, -101.59)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 7794.13,
    y1: 237.05,
    x2: 7805.49,
    y2: 254.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 8189.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6dae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d4d8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9a9fc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#838ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#757da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#777ea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#898eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 7781.53,
    cy: 244.15,
    r: 20.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 8189.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8a2076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#601652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3e0e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#23081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0f030d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4471.37,
    cy: -618.55,
    r: 5.37,
    gradientTransform: "matrix(-0.47, 0.88, 0.88, 0.47, 3142.75, -3367.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8493ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#606c90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#444d6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#303756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#232a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1f2542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#242a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#34395b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4d5179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4d517a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 4462.23,
    y1: -632.72,
    x2: 4481.8,
    y2: -632.72,
    gradientTransform: "matrix(-0.47, 0.88, 0.88, 0.47, 3142.75, -3367.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ebedf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e2e4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9097b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#767ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#888eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#949ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 9097.64,
    cy: -476.53,
    r: 12.88,
    gradientTransform: "matrix(-0.15, 0.19, 0.78, 0.62, 2216.53, -1183.75)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 1868.51,
    cy: -1359.96,
    r: 12.88,
    gradientTransform: "matrix(-0.04, 0.14, 0.82, 0.25, 1656.75, 348.77)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4462.16,
    y1: -648.47,
    x2: 4482.01,
    y2: -648.47,
    gradientTransform: "matrix(-0.47, 0.88, 0.88, 0.47, 3142.75, -3367.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d62b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8d62bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#df63c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fd62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#bf4aab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#89358f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5e2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3c1665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#240d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#150750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#160954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#251566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3f2885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6343af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7550c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6a42bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#582aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4d1ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4916a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2462.79,
    y1: -2174.52,
    x2: 2499.44,
    y2: -2172.02,
    gradientTransform: "matrix(0, 1, 1, 0, 2612.01, -2226.56)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 4462.32,
    y1: -695.41,
    x2: 4482.11,
    y2: -695.41,
    gradientTransform: "matrix(-0.47, 0.88, 0.88, 0.47, 3142.75, -3367.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#dfe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e9eaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bec1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9ca1ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#848baa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#757d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#767ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a5aad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b2b6e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9da1c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9094ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2427.84,
    y1: -2239.59,
    x2: 2464.48,
    y2: -2237.09,
    gradientTransform: "matrix(0, 1, 1, 0, 2612.01, -2226.56)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 7809.87,
    cy: 219.14,
    r: 7.7,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 4463.56,
    y1: -739.9,
    x2: 4480.48,
    y2: -739.9,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2419.09,
    y1: -2250.89,
    x2: 2450.18,
    y2: -2248.77,
    gradientTransform: "matrix(0, 1, 1, 0, 2612.01, -2226.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f760cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c249bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9737b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7529ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5d1ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4e18a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4916a1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 7821.65,
    cy: 214.17,
    r: 6.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 7738.21,
    cy: 282.9,
    r: 35.34,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 5686.92,
    cy: -7994.63,
    r: 15.75,
    gradientTransform: "matrix(-0.74, 0.68, 0.26, 0.28, 6734.52, -1315.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 7467.94,
    cy: 5135.69,
    r: 20.75,
    gradientTransform: "matrix(0, -1.15, -0.15, 0, 1173.19, 8842.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M489.19,357.83a27.4,27.4,0,0,1-13.68-3.3l-145-83.69c-5-2.88-7.85-7.44-7.85-12.51,0-5.56,3.44-10.73,9.45-14.2l82.27-47.5A33.75,33.75,0,0,1,431,192.4a27.52,27.52,0,0,1,13.69,3.3l145,83.69c5,2.89,7.85,7.45,7.85,12.51,0,5.56-3.45,10.74-9.46,14.21L505.82,353.6A33.68,33.68,0,0,1,489.19,357.83Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.78,197.26a32.92,32.92,0,0,1,16.58-4.11,32,32,0,0,1,6.79.83,27.08,27.08,0,0,1,6.77,2.67L589.32,280c5,2.87,7.56,7.42,7.26,12.35a14.26,14.26,0,0,1-.87,4c-1.26,3.53-4.83,7.29-8.89,9.63l-81.1,46.82a31.27,31.27,0,0,1-3.53,1.74,34.51,34.51,0,0,1-12.82,2.54,26.84,26.84,0,0,1-13.5-3.2l-145-83.69c-5-2.87-7.55-7.43-7.23-12.38a15.1,15.1,0,0,1,.69-3.44c1.16-3.74,4.86-7.74,9.12-10.2Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.14,197.89a32.21,32.21,0,0,1,16.53-4,31.76,31.76,0,0,1,6.74.94,31.09,31.09,0,0,1,6.7,2.76l143.85,83c4.94,2.86,7.27,7.38,6.66,12.19a16,16,0,0,1-1.07,3.81c-1.23,3.14-5.35,7.13-9,9.24L505.62,352a34.94,34.94,0,0,1-3.46,1.74,34.09,34.09,0,0,1-12.61,2.59,26.22,26.22,0,0,1-13.32-3.1l-145-83.69c-5-2.86-7.27-7.42-6.61-12.24a16.86,16.86,0,0,1,.88-3.29c1.15-3.33,5.44-7.58,9.28-9.79Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415.51,198.51A31.56,31.56,0,0,1,432,194.64a31,31,0,0,1,6.68,1.07,36.64,36.64,0,0,1,6.63,2.83l143.3,82.74c4.92,2.84,7,7.34,6.06,12a18.25,18.25,0,0,1-1.27,3.63c-1.19,2.75-5.86,7-9.1,8.85l-78.77,45.47c-.82.48-2.49,1.34-3.4,1.73a33.38,33.38,0,0,1-12.4,2.64,25.45,25.45,0,0,1-13.13-3L331.64,269c-5-2.86-7-7.4-6-12.1a19.56,19.56,0,0,1,1.06-3.13c1.13-2.92,6-7.43,9.44-9.4Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M415.87,199.14a30.88,30.88,0,0,1,16.43-3.75,30.54,30.54,0,0,1,6.62,1.18,43,43,0,0,1,6.56,2.92l142.75,82.42c4.9,2.82,6.72,7.3,5.47,11.87a21.62,21.62,0,0,1-1.48,3.44c-1.11,2.37-6.36,6.82-9.2,8.46l-77.59,44.8c-.72.41-2.56,1.38-3.35,1.72a32.68,32.68,0,0,1-12.18,2.7A25,25,0,0,1,477,352L332,268.33c-4.94-2.86-6.71-7.38-5.36-12a28.67,28.67,0,0,1,1.26-3c1.08-2.52,6.62-7.27,9.6-9Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M416.23,199.77a28.81,28.81,0,0,1,22.95-2.34,52.88,52.88,0,0,1,6.49,3l142.2,82.1c4.88,2.81,6.45,7.26,4.88,11.71a28.92,28.92,0,0,1-1.69,3.25c-1,2-6.87,6.67-9.31,8.07L505.33,349.7c-.62.35-2.61,1.42-3.28,1.72a32.67,32.67,0,0,1-12,2.75,24.36,24.36,0,0,1-12.75-2.78l-145-83.69c-4.93-2.85-6.44-7.36-4.73-11.84.36-1,1-1.82,1.45-2.81,1-2.13,7.2-7.12,9.76-8.59Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.59,200.4a27.71,27.71,0,0,1,22.85-2.1,65.6,65.6,0,0,1,6.42,3.08l141.65,81.78c4.85,2.8,6.19,7.22,4.28,11.56a12.62,12.62,0,0,1-1.89,3.06c-.58,1.79-7.38,6.51-9.41,7.69l-75.26,43.45c-.51.29-2.66,1.46-3.22,1.71a32,32,0,0,1-11.76,2.81,23.82,23.82,0,0,1-12.57-2.68L332.73,267.07c-4.92-2.84-6.2-7.34-4.12-11.71a12.75,12.75,0,0,1,1.65-2.65c.52-1.88,7.78-7,9.91-8.19Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M417,201a28.81,28.81,0,0,1,16.28-3.4,29.39,29.39,0,0,1,6.46,1.53c.9.29,5.62,2.75,6.35,3.17l141.1,81.46c4.82,2.79,6,7.19,3.68,11.4a13,13,0,0,1-2.09,2.88c-.46,1.42-7.89,6.35-9.52,7.29l-74.09,42.78c-.41.23-2.71,1.5-3.16,1.7a31.48,31.48,0,0,1-11.55,2.87A23.26,23.26,0,0,1,478,350.13l-145-83.69c-4.91-2.83-5.95-7.32-3.49-11.57a13,13,0,0,1,1.83-2.49c.42-1.51,8.37-6.81,10.08-7.79Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M417.32,201.66a28.21,28.21,0,0,1,16.24-3.28A28.67,28.67,0,0,1,440,200c.67.23,5.73,2.94,6.28,3.26l140.54,81.14c4.81,2.77,5.72,7.16,3.09,11.24a13.38,13.38,0,0,1-2.29,2.69c-.35,1.07-8.4,6.2-9.62,6.9L505,347.35c-.31.18-2.77,1.55-3.1,1.7A31.14,31.14,0,0,1,490.6,352a22.67,22.67,0,0,1-12.19-2.48l-145-83.69c-4.89-2.82-5.72-7.32-2.86-11.44a13.42,13.42,0,0,1,2-2.33c.31-1.13,9-6.65,10.23-7.39Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M417.68,202.28a27.66,27.66,0,0,1,16.19-3.16,28.44,28.44,0,0,1,6.35,1.77c.44.15,5.84,3.12,6.21,3.33l140,80.83c4.78,2.76,5.5,7.14,2.49,11.07a13.4,13.4,0,0,1-2.49,2.51c-.24.71-8.92,6.05-9.73,6.52l-71.75,41.42c-.21.12-2.82,1.59-3,1.7a30.65,30.65,0,0,1-11.13,3c-4.48.24-8.83-.54-12-2.37l-145-83.69c-4.88-2.82-5.5-7.33-2.24-11.31a13.48,13.48,0,0,1,2.22-2.17c.21-.76,9.54-6.5,10.39-7Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418.05,202.91a27,27,0,0,1,16.14-3,27.75,27.75,0,0,1,6.29,1.88c.22.08,5.95,3.31,6.14,3.42l139.44,80.51c4.75,2.74,5.28,7.14,1.89,10.91a14.36,14.36,0,0,1-2.7,2.33c-.11.35-9.42,5.88-9.82,6.12l-70.59,40.75c-.1.06-2.87,1.64-3,1.69a30,30,0,0,1-10.91,3c-4.4.28-8.71-.47-11.82-2.26L334.18,264.56c-4.87-2.81-5.29-7.35-1.62-11.17a14.54,14.54,0,0,1,2.41-2c.1-.38,10.12-6.34,10.55-6.58Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5,347.62l-145-83.69c-5.72-3.31-5-9.08,1.6-12.89l82.27-47.5c6.61-3.82,16.61-4.23,22.33-.93l145,83.69c5.72,3.31,5,9.08-1.61,12.9l-82.26,47.49C495.22,350.51,485.22,350.92,479.5,347.62Z",
    transform: "translate(-322.7 -59.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M479.5,347.49l-145-83.69c-2.55-1.48-3.82-3.44-3.86-5.5v-7.18c0-2.51,1.89,1.84,5.46-.22l82.27-47.49c6.61-3.82,16.61-4.23,22.33-.93l145,83.69c1.91,1.1,3.29-3.58,3.79-2.09.16.5.06,7.07.07,7.58.05,2.57-1.8,5.29-5.47,7.41l-82.26,47.49C495.22,350.38,485.22,350.79,479.5,347.49Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M479.5,340.44l-145-83.69c-5.72-3.31-5-9.08,1.6-12.89l82.27-47.5c6.61-3.82,16.61-4.23,22.33-.93l145,83.69c5.72,3.31,5,9.08-1.61,12.9l-82.26,47.49C495.22,343.33,485.22,343.74,479.5,340.44Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M489.19,339.78a16.9,16.9,0,0,1-8.25-1.85L336,254.24c-.91-.52-2.42-1.61-2.42-3.09s1.5-3.33,4-4.79l82.27-47.49A23,23,0,0,1,431,196.1a16.9,16.9,0,0,1,8.25,1.84l145,83.69c.9.52,2.41,1.62,2.41,3.09s-1.5,3.34-4,4.79L500.38,337A23,23,0,0,1,489.19,339.78Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M584.09,290.82l-82.26,47.5c-6.61,3.81-16.61,4.23-22.33.92l-145-83.69c-2.37-1.37-3.62-3.17-3.82-5.07-.3,2.34.95,4.61,3.82,6.27l145,83.69c5.72,3.3,15.72,2.89,22.33-.93L584.09,292c3.87-2.24,5.7-5.14,5.43-7.82C589.22,286.53,587.39,288.92,584.09,290.82Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 415.14,
    cy: 226.46,
    rx: 36.19,
    ry: 21.37,
    transform: "translate(-373.78 88.34) rotate(-18.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M505.25,309.61l-117.71-68c-2.35-1.36-2.06-3.74.66-5.31l44.2-25.51c2.72-1.58,6.84-1.75,9.19-.39l117.71,68c2.36,1.36,2.07,3.73-.66,5.3l-44.19,25.52C511.73,310.8,507.61,311,505.25,309.61Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M435,215.79l7.54,4.36a3.83,3.83,0,0,0,3.46,0c.95-.55.95-1.44,0-2l-7.54-4.35a3.82,3.82,0,0,0-3.47,0A1.06,1.06,0,0,0,435,215.79Zm12.91,7.46,3.57,2.06a3.86,3.86,0,0,0,3.47,0,1.06,1.06,0,0,0,0-2l-3.58-2.06a3.8,3.8,0,0,0-3.46,0C446.93,221.8,446.93,222.69,447.89,223.25Zm8.95,5.16,3.57,2.07a3.83,3.83,0,0,0,3.46,0c.95-.55.95-1.44,0-2l-3.57-2.06a3.86,3.86,0,0,0-3.47,0A1.06,1.06,0,0,0,456.84,228.41Zm8.94,5.17,3.57,2.06a3.86,3.86,0,0,0,3.47,0,1.06,1.06,0,0,0,0-2l-3.58-2.07a3.83,3.83,0,0,0-3.46,0C464.82,232.13,464.82,233,465.78,233.58Zm9,5.16,3.57,2.06a3.8,3.8,0,0,0,3.46,0,1.06,1.06,0,0,0,0-2l-3.57-2.06a3.82,3.82,0,0,0-3.47,0A1.06,1.06,0,0,0,474.73,238.74Zm8.94,5.17,3.57,2.06a3.82,3.82,0,0,0,3.47,0c1-.55.94-1.44,0-2l-3.57-2.07a3.83,3.83,0,0,0-3.46,0C482.71,242.46,482.71,243.35,483.67,243.91Zm8.94,5.16,3.58,2.06a3.8,3.8,0,0,0,3.46,0,1.06,1.06,0,0,0,0-2l-3.57-2.06a3.82,3.82,0,0,0-3.47,0A1.06,1.06,0,0,0,492.61,249.07Zm8.95,5.16,3.57,2.07a3.86,3.86,0,0,0,3.47,0c.95-.55.94-1.44,0-2L505,252.24a3.8,3.8,0,0,0-3.46,0A1,1,0,0,0,501.56,254.23Zm8.94,5.17,3.58,2.06a3.8,3.8,0,0,0,3.46,0,1.06,1.06,0,0,0,0-2L514,257.41a3.82,3.82,0,0,0-3.47,0C509.54,258,509.55,258.84,510.5,259.4Zm9,5.16,3.57,2.07a3.86,3.86,0,0,0,3.47,0c1-.55.94-1.44,0-2l-3.57-2.06a3.83,3.83,0,0,0-3.46,0A1.06,1.06,0,0,0,519.45,264.56Zm8.94,5.17,3.58,2.06a3.83,3.83,0,0,0,3.46,0,1.06,1.06,0,0,0,0-2l-3.57-2.07a3.86,3.86,0,0,0-3.47,0C527.43,268.28,527.44,269.17,528.39,269.73Zm9,5.16,3.57,2.06a3.82,3.82,0,0,0,3.47,0c1-.55.94-1.44,0-2l-3.57-2.06a3.8,3.8,0,0,0-3.46,0A1.06,1.06,0,0,0,537.34,274.89Zm9.13,5.27,3.57,2.07a3.86,3.86,0,0,0,3.47,0c1-.55.94-1.44,0-2l-3.58-2.06a3.83,3.83,0,0,0-3.46,0A1.06,1.06,0,0,0,546.47,280.16ZM426.93,220.71,430,222.5a4.37,4.37,0,0,0,3.94,0l3.08-1.78a1.2,1.2,0,0,0,0-2.27l-3.1-1.79a4.37,4.37,0,0,0-3.94,0l-3.07,1.78C425.83,219.06,425.84,220.08,426.93,220.71Zm16,7L446,225.9a1.2,1.2,0,0,0,0-2.28l-3.09-1.79a4.34,4.34,0,0,0-3.94,0l-3.08,1.77a1.2,1.2,0,0,0,0,2.28l3.09,1.78A4.34,4.34,0,0,0,442.91,227.67Zm1.91,3.37,3.09,1.79a4.37,4.37,0,0,0,3.94,0l3.08-1.78a1.2,1.2,0,0,0,0-2.27l-3.1-1.79a4.37,4.37,0,0,0-3.94,0l-3.07,1.78C443.72,229.39,443.73,230.41,444.82,231Zm8.94,5.17,3.1,1.78a4.34,4.34,0,0,0,3.94,0l3.07-1.78c1.09-.62,1.08-1.64,0-2.27l-3.09-1.79a4.34,4.34,0,0,0-3.94,0l-3.08,1.77A1.21,1.21,0,0,0,453.76,236.21Zm19.05,2.9-3.1-1.78a4.34,4.34,0,0,0-3.94,0l-3.07,1.78c-1.09.62-1.08,1.64,0,2.27l3.09,1.79a4.34,4.34,0,0,0,3.94,0l3.08-1.77A1.21,1.21,0,0,0,472.81,239.11Zm8.94,5.17-3.09-1.79a4.34,4.34,0,0,0-3.94,0l-3.08,1.77a1.21,1.21,0,0,0,0,2.28l3.1,1.78a4.37,4.37,0,0,0,3.94,0l3.07-1.78C482.85,245.93,482.84,244.91,481.75,244.28Zm8.95,5.16-3.1-1.78a4.34,4.34,0,0,0-3.94,0l-3.07,1.77a1.2,1.2,0,0,0,0,2.28l3.09,1.79a4.34,4.34,0,0,0,3.94,0l3.08-1.77A1.21,1.21,0,0,0,490.7,249.44Zm8.94,5.17-3.09-1.79a4.37,4.37,0,0,0-3.94,0l-3.08,1.78a1.2,1.2,0,0,0,0,2.27l3.1,1.79a4.37,4.37,0,0,0,3.94,0l3.07-1.78C500.74,256.26,500.73,255.24,499.64,254.61Zm8.95,5.16-3.1-1.78a4.31,4.31,0,0,0-3.94,0l-3.07,1.77a1.2,1.2,0,0,0,0,2.28l3.09,1.78a4.34,4.34,0,0,0,3.94,0l3.08-1.77A1.21,1.21,0,0,0,508.59,259.77Zm8.94,5.17-3.09-1.79a4.37,4.37,0,0,0-3.94,0l-3.08,1.78a1.2,1.2,0,0,0,0,2.27l3.1,1.79a4.37,4.37,0,0,0,3.94,0l3.07-1.78C518.63,266.58,518.62,265.57,517.53,264.94Zm-1.15,7.42,3.09,1.78a4.34,4.34,0,0,0,3.94,0l3.08-1.77a1.21,1.21,0,0,0,0-2.28l-3.1-1.79a4.34,4.34,0,0,0-3.94,0l-3.07,1.77A1.2,1.2,0,0,0,516.38,272.36Zm19,2.9-3.09-1.78a4.34,4.34,0,0,0-3.94,0l-3.08,1.78a1.2,1.2,0,0,0,0,2.27l3.1,1.79a4.34,4.34,0,0,0,3.94,0l3.07-1.77A1.2,1.2,0,0,0,535.42,275.26Zm13.1,7.57-7.06-4.08a4.37,4.37,0,0,0-3.94,0l-3.08,1.78c-1.08.62-1.08,1.64,0,2.27l7.06,4.08a4.37,4.37,0,0,0,3.94,0l3.07-1.78C549.62,284.48,549.61,283.46,548.52,282.83ZM418.65,225.5l7.06,4.07a4.31,4.31,0,0,0,3.94,0l3.07-1.77a1.2,1.2,0,0,0,0-2.28l-7.06-4.08a4.34,4.34,0,0,0-3.94,0l-3.08,1.77A1.2,1.2,0,0,0,418.65,225.5ZM431.56,233l3.09,1.79a4.37,4.37,0,0,0,3.94,0l3.08-1.78a1.2,1.2,0,0,0,0-2.27l-3.1-1.79a4.37,4.37,0,0,0-3.94,0l-3.07,1.78C430.46,231.3,430.47,232.32,431.56,233Zm12,7a4.34,4.34,0,0,0,3.94,0l3.07-1.77a1.2,1.2,0,0,0,0-2.28l-3.09-1.79a4.34,4.34,0,0,0-3.94,0l-3.08,1.77a1.2,1.2,0,0,0,0,2.28Zm8.94,5.17a4.37,4.37,0,0,0,3.94,0l3.08-1.78a1.21,1.21,0,0,0,0-2.28l-3.1-1.78a4.37,4.37,0,0,0-3.94,0L449.44,241c-1.09.62-1.08,1.64,0,2.27Zm8.92-.67-3.08,1.77a1.21,1.21,0,0,0,0,2.28l3.1,1.78a4.34,4.34,0,0,0,3.94,0l3.07-1.78c1.09-.62,1.08-1.64,0-2.27l-3.09-1.79A4.34,4.34,0,0,0,461.46,244.4Zm9.13,5-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2a3.94,3.94,0,0,0,3.57,0l3.45-2a1.09,1.09,0,0,0,0-2.06l-3.48-2A4,4,0,0,0,470.59,249.45Zm9,5.17-3.46,2a1.09,1.09,0,0,0,0,2.06l3.48,2a4,4,0,0,0,3.56,0l3.45-2c1-.56,1-1.48,0-2.05l-3.47-2A3.92,3.92,0,0,0,479.54,254.62Zm8.94,5.16-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2a4,4,0,0,0,3.57,0l3.45-2a1.09,1.09,0,0,0,0-2.06l-3.48-2A3.92,3.92,0,0,0,488.48,259.78Zm8.95,5.16-3.46,2c-1,.56-1,1.48,0,2.05l3.48,2a4,4,0,0,0,3.56,0l3.45-2c1-.56,1-1.48,0-2.05L501,265A4,4,0,0,0,497.43,264.94Zm8.94,5.17-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2a3.92,3.92,0,0,0,3.56,0l3.46-2a1.09,1.09,0,0,0,0-2.06l-3.48-2A3.92,3.92,0,0,0,506.37,270.11Zm12.54,11.22,3.45-2a1.08,1.08,0,0,0,0-2l-3.47-2a4,4,0,0,0-3.56,0l-3.46,2c-1,.56-1,1.48,0,2.05l3.48,2A3.92,3.92,0,0,0,518.91,281.33Zm8.94,5.17,3.46-2a1.09,1.09,0,0,0,0-2.06l-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2A3.92,3.92,0,0,0,527.85,286.5Zm12.58,1.22-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2a3.94,3.94,0,0,0,3.57,0l3.45-2A1.09,1.09,0,0,0,540.43,287.72ZM410.17,230.17l11.22,6.48a3.92,3.92,0,0,0,3.56,0l3.45-2a1.09,1.09,0,0,0,0-2.06l-11.22-6.47a3.92,3.92,0,0,0-3.56,0l-3.45,2A1.09,1.09,0,0,0,410.17,230.17Zm16.69,9.63,3.47,2a4,4,0,0,0,3.56,0l3.45-2c1-.56,1-1.48,0-2l-3.47-2a4,4,0,0,0-3.56,0l-3.45,2C425.86,238.31,425.87,239.23,426.86,239.8ZM435.8,245l3.48,2a3.92,3.92,0,0,0,3.56,0l3.45-2a1.09,1.09,0,0,0,0-2.06l-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2A1.09,1.09,0,0,0,435.8,245Zm8.95,5.16,3.47,2a4,4,0,0,0,3.56,0l3.45-2c1-.56,1-1.48,0-2.05l-3.47-2a4,4,0,0,0-3.56,0l-3.45,2C443.75,248.64,443.76,249.56,444.75,250.13Zm16,7.18,3.45-2a1.09,1.09,0,0,0,0-2.06l-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2A3.94,3.94,0,0,0,460.73,257.31Zm8.94,5.16,3.45-2a1.09,1.09,0,0,0,0-2.06l-3.47-2a4,4,0,0,0-3.56,0l-3.46,2c-1,.56-1,1.48,0,2l3.47,2A3.92,3.92,0,0,0,469.67,262.47Zm8.95,5.17,3.45-2a1.09,1.09,0,0,0,0-2.06l-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2a1.09,1.09,0,0,0,0,2.06l3.47,2A4,4,0,0,0,478.62,267.64Zm8.94,5.16,3.45-2a1.09,1.09,0,0,0,0-2.06l-3.47-2a3.92,3.92,0,0,0-3.56,0l-3.46,2c-1,.57-1,1.49,0,2.06l3.47,2A3.92,3.92,0,0,0,487.56,272.8Zm8.95,5.17,3.45-2c1-.56,1-1.48,0-2.05l-3.48-2a3.92,3.92,0,0,0-3.56,0l-3.45,2a1.08,1.08,0,0,0,0,2.05l3.47,2A4,4,0,0,0,496.51,278Zm8.94,5.16,3.45-2a1.09,1.09,0,0,0,0-2.06l-3.47-2a3.92,3.92,0,0,0-3.56,0l-3.46,2c-1,.57-1,1.49,0,2.06l3.47,2A3.92,3.92,0,0,0,505.45,283.13Zm1.91,3.15,3.47,2a4,4,0,0,0,3.57,0l3.45-2c1-.56,1-1.48,0-2.05l-3.48-2a4,4,0,0,0-3.56,0l-3.45,2C506.37,284.79,506.37,285.71,507.36,286.28Zm24.78,6.22-8.83-5.1a4,4,0,0,0-3.56,0l-3.46,2c-1,.57-1,1.49,0,2.06l8.83,5.1a3.92,3.92,0,0,0,3.56,0l3.45-2A1.09,1.09,0,0,0,532.14,292.5ZM401.92,235.2l15.91,9.19a4.47,4.47,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-15.92-9.19a4.42,4.42,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,401.92,235.2Zm21.85,12.61,3,1.74a4.42,4.42,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.48,4.48,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,423.77,247.81Zm8.94,5.17,3,1.74a4.47,4.47,0,0,0,4,0l3-1.72c1.11-.64,1.1-1.68,0-2.33l-3-1.73a4.42,4.42,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,432.71,253Zm9,5.16,3,1.74a4.42,4.42,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,441.66,258.14Zm8.94,5.17,3,1.74a4.47,4.47,0,0,0,4,0l3-1.72c1.11-.64,1.1-1.68,0-2.33l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.73C449.48,261.62,449.49,262.66,450.6,263.31Zm8.95,5.16,3,1.74a4.45,4.45,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,459.55,268.47Zm8.94,5.17,3,1.73a4.44,4.44,0,0,0,4,0l3-1.73c1.1-.63,1.1-1.67,0-2.32l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.72C467.37,272,467.38,273,468.49,273.64Zm8.95,5.16,3,1.74a4.45,4.45,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.42,4.42,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,477.44,278.8Zm8.94,5.17,3,1.73a4.44,4.44,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.72C485.26,282.28,485.27,283.32,486.38,284Zm8.95,5.16,3,1.74a4.48,4.48,0,0,0,4,0l3-1.73c1.11-.64,1.1-1.68,0-2.33l-3-1.73a4.42,4.42,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,495.33,289.13Zm8.94,5.16,3,1.74a4.44,4.44,0,0,0,4,0l3-1.73a1.22,1.22,0,0,0,0-2.32l-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.73A1.22,1.22,0,0,0,504.27,294.29Zm19.16,3-3-1.74a4.47,4.47,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l3,1.74a4.47,4.47,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,523.43,297.27ZM407.62,240l-7-4a4.47,4.47,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l7,4a4.44,4.44,0,0,0,4,0l3-1.73C408.74,241.66,408.73,240.62,407.62,240Zm8.94,5.17-3-1.74a4.42,4.42,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l3,1.74a4.45,4.45,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,416.56,245.14Zm8.95,5.16-3-1.74a4.47,4.47,0,0,0-4,0l-3,1.72c-1.11.64-1.1,1.68,0,2.33l3,1.73a4.44,4.44,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,425.51,250.3Zm62.61,36.15-56.68-32.72a4.42,4.42,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l56.68,32.72a4.42,4.42,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,488.12,286.45Zm8.95,5.17-3-1.74a4.44,4.44,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l3,1.74a4.47,4.47,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,497.07,291.62Zm8.94,5.16L503,295a4.45,4.45,0,0,0-4,0l-3,1.73a1.22,1.22,0,0,0,0,2.32l3,1.74a4.42,4.42,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,506,296.78Zm9.13,5.27-3-1.74a4.45,4.45,0,0,0-4,0l-3,1.72a1.23,1.23,0,0,0,0,2.33l3,1.73a4.42,4.42,0,0,0,4,0l3-1.73A1.22,1.22,0,0,0,515.14,302.05Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M583.4,278,443.73,197.33c-5.4-3.12-9.79-11.5-9.79-18.71V69.06c0-7.21,4.39-10.53,9.79-7.4L583.4,142.34c5.41,3.12,9.79,11.5,9.79,18.71V270.61C593.19,277.82,588.81,281.13,583.4,278Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M584.66,272.38,446.48,192.57c-4.35-2.77-7-8.29-7-13.95V68.53a1.74,1.74,0,0,1,2.62-1.5l.3.18L580.65,147.1c5.18,3,7,8.29,7,14V270.89a1.87,1.87,0,0,1-2.8,1.62Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M580.65,147.1,442.36,67.21l-.3-.18a1.74,1.74,0,0,0-2.62,1.5V178.62c0,5.66,2.69,11.18,7,13.95l138.18,79.81.23.13a1.87,1.87,0,0,0,2.8-1.62V161.05C587.69,155.39,585.83,150.09,580.65,147.1Zm5.94,123.79a.78.78,0,0,1-.78.77.75.75,0,0,1-.38-.1L447,191.62c-3.93-2.5-6.5-7.61-6.5-13V68.53a.64.64,0,0,1,.64-.64.62.62,0,0,1,.32.09l138.6,80.07c5.36,3.1,6.49,8.78,6.49,13Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M586.17,140.87,446.51,60.18a6.64,6.64,0,0,0-5.73-.84c-.21.08-2.93,1.53-3.13,1.64h0c1.67-.81,3.79-.66,6.09.68L583.4,142.34c5.41,3.12,9.79,11.5,9.79,18.71V270.61c0,4.5-1.71,7.48-4.31,8.33a1.62,1.62,0,0,0,.86-.29c.13-.08,3.09-1.75,3.21-1.83,1.86-1.3,3-4,3-7.68V159.57C596,152.36,591.58,144,586.17,140.87Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M583.87,142.1,444.2,61.42C442,60.14,440,60,438.31,60.67a7.22,7.22,0,0,1,4.72,1.1l139.66,80.69c5.41,3.12,9.79,11.49,9.79,18.7V270.73c0,4.25-1.53,7.13-3.89,8.15,3-.48,5.07-3.58,5.07-8.5V160.81C593.66,153.6,589.28,145.23,583.87,142.1Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M561.64,156.37,462.29,99.92c-.25,13.23,0,54.67-.1,68.21-.12,21.92-3.4,39.19-28.71,59-8.05,6.3-43.58,25.66-72.42,40.81-11.69,6.15-12.58,8.74-18.5,13.75-5.73,4.86-14.52,9.37-17.09,10.87l98.69,57.06c1.84-1.09,11.44-5.91,17.75-11.25,5.91-5,6.8-10.35,18.5-16.5,28.83-15.15,78.23-45.49,87-50.75,11.25-6.75,14.12-11,14.12-28.75C561.53,228.76,561.38,169.35,561.64,156.37Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M561.64,149.87,462.29,93.42c-.25,13.23,0,54.67-.1,68.21-.12,21.92-3.4,39.19-28.71,59-8.05,6.3-43.58,25.66-72.42,40.81-11.69,6.15-13.58,14-19.5,19-5.73,4.86-12.08,6.18-14.65,7.68l98.68,57.07c1.85-1.1,9-2.73,15.32-8.07,5.91-5,7.8-12.85,19.5-19,28.83-15.15,64.36-34.51,72.41-40.81,25.31-19.81,28.59-37.08,28.71-59C561.61,204.69,561.38,162.85,561.64,149.87Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M503.41,195.51a.48.48,0,0,1-.26-.07l-.1-.06a.49.49,0,0,1-.18-.68l0,0v-2.52a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V195a.49.49,0,0,1-.26.43A.42.42,0,0,1,503.41,195.51Zm-2.7-1.56a.45.45,0,0,1-.25-.07l-2.6-1.51a.49.49,0,0,1-.18-.68.51.51,0,0,1,.69-.18L501,193a.51.51,0,0,1,.18.69A.5.5,0,0,1,500.71,194Zm-5.19-3a.55.55,0,0,1-.25-.07l-2.6-1.51a.49.49,0,0,1-.18-.68.51.51,0,0,1,.69-.18l2.59,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,495.52,190.94Zm7.89-1.31a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.51.51,0,0,1,503.41,189.63Zm-13.08-1.7a.55.55,0,0,1-.25-.07l-2.6-1.51a.5.5,0,1,1,.51-.86l2.59,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,490.33,187.93Zm-5.19-3a.54.54,0,0,1-.25-.06l-2.6-1.51a.49.49,0,0,1-.18-.68.51.51,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1-.25.93Zm18.27-1.28a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.51.51,0,0,1,503.41,183.63ZM480,181.9a.54.54,0,0,1-.25-.06l-2.6-1.51a.5.5,0,1,1,.51-.86l2.59,1.5a.5.5,0,0,1-.25.93Zm-5.19-3a.54.54,0,0,1-.25-.06l-2.6-1.51a.5.5,0,0,1-.24-.43v-1.68a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.39L475,178a.5.5,0,0,1-.25.93Zm28.65-1.26a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.51.51,0,0,1,503.41,177.63Zm-31.24-4.92a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,472.17,172.71Zm31.24-1.08a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.51.51,0,0,1,503.41,171.63Zm-31.24-4.92a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,472.17,166.71Zm31.24-1.08a.5.5,0,0,1-.5-.5v-.55l-1.63-.94a.51.51,0,0,1-.18-.69.51.51,0,0,1,.69-.18l1.87,1.09a.5.5,0,0,1,.25.43v.84A.51.51,0,0,1,503.41,165.63Zm-4.47-3.43a.45.45,0,0,1-.25-.07l-2.6-1.5a.51.51,0,0,1-.18-.69.51.51,0,0,1,.69-.18l2.59,1.51a.5.5,0,0,1-.25.93Zm-26.77-1.49a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,472.17,160.71Zm21.58-1.52a.47.47,0,0,1-.25-.07l-2.6-1.5a.51.51,0,0,1-.18-.69.51.51,0,0,1,.69-.18l2.59,1.51a.5.5,0,0,1-.25.93Zm-5.19-3a.45.45,0,0,1-.25-.07l-2.6-1.51a.5.5,0,0,1-.18-.68.51.51,0,0,1,.69-.18l2.59,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,488.56,156.18Zm-16.39-1.47a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,472.17,154.71Zm11.2-1.54a.47.47,0,0,1-.25-.07l-2.59-1.51a.5.5,0,1,1,.5-.86l2.59,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,483.37,153.17Zm-5.19-3a.55.55,0,0,1-.25-.07l-2.6-1.51a.5.5,0,1,1,.51-.86l2.59,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,478.18,150.16Zm-6-1.45a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.75-.44l.82.48a.5.5,0,0,1-.5.87l-.07-.05v1.18A.5.5,0,0,1,472.17,148.71Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M551.41,207.51a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3A.5.5,0,0,1,551.41,207.51Zm-2.23-.82a.53.53,0,0,1-.24-.06l-2.61-1.49a.5.5,0,1,1,.49-.87l2.61,1.49a.49.49,0,0,1,.19.68A.5.5,0,0,1,549.18,206.69Zm-5.21-3a.57.57,0,0,1-.25-.06l-2.6-1.49a.49.49,0,0,1-.19-.68.5.5,0,0,1,.68-.19l2.61,1.49a.51.51,0,0,1,.19.68A.52.52,0,0,1,544,203.72Zm7.44-2.21a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,551.41,201.51Zm-12.65-.75a.55.55,0,0,1-.25-.07l-2.61-1.48a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.6,1.48a.5.5,0,0,1,.19.68A.51.51,0,0,1,538.76,200.76Zm-5.22-3a.47.47,0,0,1-.25-.07l-2.6-1.48a.5.5,0,1,1,.49-.87l2.61,1.48a.51.51,0,0,1,.19.68A.5.5,0,0,1,533.54,197.79Zm17.87-2.28a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,551.41,195.51Zm-23.08-.69a.45.45,0,0,1-.25-.07l-2.61-1.48a.5.5,0,0,1,.5-.87l2.6,1.48a.51.51,0,0,1,.19.69A.5.5,0,0,1,528.33,194.82Zm-5.22-3a.5.5,0,0,1-.24-.06l-2.61-1.49a.5.5,0,1,1,.49-.87l2.61,1.49a.5.5,0,0,1-.25.93Zm25.9-.95a.5.5,0,0,1-.24-.06l-2.61-1.49a.5.5,0,1,1,.49-.87l2.61,1.49a.5.5,0,0,1-.25.93Zm-31.11-2a.54.54,0,0,1-.25-.06L515,187.33a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.61,1.49a.5.5,0,0,1-.25.93Zm25.9-.95a.57.57,0,0,1-.25-.06l-2.6-1.49a.49.49,0,0,1-.19-.68.5.5,0,0,1,.68-.19l2.61,1.49a.5.5,0,0,1-.25.93Zm-31.12-2a.5.5,0,0,1-.24-.06l-2.61-1.49a.5.5,0,0,1-.19-.68.49.49,0,0,1,.68-.18l2.61,1.48a.51.51,0,0,1,.19.68A.5.5,0,0,1,512.68,185.91Zm25.9-.94a.55.55,0,0,1-.24-.07l-2.61-1.48a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.6,1.48a.5.5,0,0,1,.19.68A.51.51,0,0,1,538.58,185Zm-30.51-2.37a.51.51,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,508.07,182.6Zm25.3-.6a.47.47,0,0,1-.25-.07l-2.6-1.48a.5.5,0,0,1,.49-.87l2.61,1.48a.51.51,0,0,1,.19.68A.51.51,0,0,1,533.37,182Zm-5.21-3a.45.45,0,0,1-.25-.07l-2.61-1.48a.5.5,0,0,1,.5-.87l2.6,1.48a.51.51,0,0,1,.19.69A.5.5,0,0,1,528.16,179Zm-20.09-2.43a.51.51,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,508.07,176.6Zm14.87-.54a.5.5,0,0,1-.24-.06l-2.61-1.49a.5.5,0,0,1,.49-.87l2.61,1.49a.5.5,0,0,1-.25.93Zm-5.21-3a.54.54,0,0,1-.25-.06l-2.61-1.49a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.6,1.49a.5.5,0,0,1-.24.93Zm-9.66-2.49a.51.51,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,508.07,170.6Zm4.44-.48a.5.5,0,0,1-.24-.06l-2.61-1.49a.49.49,0,1,1,.49-.86l2.61,1.48a.51.51,0,0,1,.19.68A.5.5,0,0,1,512.51,170.12Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M476.07,127.27a.78.78,0,0,1-.11-.36v-9.7l-2.83-1.64a.7.7,0,0,1-.27-.27.75.75,0,0,1-.1-.38V113.6a.29.29,0,0,1,.1-.26q.09-.06.27,0L481,117.9a.83.83,0,0,1,.28.28.75.75,0,0,1,.1.38v1.32c0,.13,0,.21-.1.25a.27.27,0,0,1-.28,0l-2.82-1.63v9.69a.28.28,0,0,1-.1.25.26.26,0,0,1-.27,0l-1.44-.83A.75.75,0,0,1,476.07,127.27Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M482.66,120.43a.72.72,0,0,1-.11-.36v-1.29a.27.27,0,0,1,.11-.25.25.25,0,0,1,.26,0l1.41.81a.75.75,0,0,1,.28.28.79.79,0,0,1,.11.38v1.29a.24.24,0,0,1-.12.23.27.27,0,0,1-.27,0l-1.41-.82A.75.75,0,0,1,482.66,120.43Zm.06,10.68a.7.7,0,0,1-.1-.36v-8.31c0-.12,0-.21.1-.24a.28.28,0,0,1,.26,0l1.31.76a.75.75,0,0,1,.26.27.72.72,0,0,1,.11.36v8.31a.25.25,0,0,1-.11.23.27.27,0,0,1-.26,0l-1.31-.76A.84.84,0,0,1,482.72,131.11Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M488.2,133.56a5.73,5.73,0,0,1-.71-2.87v-4l-1.21-.7a.75.75,0,0,1-.26-.27.78.78,0,0,1-.11-.36v-1a.22.22,0,0,1,.37-.21l1.21.7v-2.92c0-.13,0-.22.11-.25a.29.29,0,0,1,.26,0l1.27.73a.87.87,0,0,1,.27.27.69.69,0,0,1,.1.37V126l1.92,1.1a.71.71,0,0,1,.26.28.72.72,0,0,1,.11.36v1a.25.25,0,0,1-.11.23.27.27,0,0,1-.26,0l-1.92-1.11v3.78a3.22,3.22,0,0,0,.23,1.28,1.75,1.75,0,0,0,.75.82l1.07.62a.59.59,0,0,1,.27.27.65.65,0,0,1,.1.36v1.11a.25.25,0,0,1-.1.24q-.09.07-.27,0l-1.25-.73A5.43,5.43,0,0,1,488.2,133.56Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M493.41,137.28a.72.72,0,0,1-.11-.36V125.27a.26.26,0,0,1,.11-.25.29.29,0,0,1,.26,0l1.29.75a.75.75,0,0,1,.27.26.82.82,0,0,1,.1.37v11.65a.3.3,0,0,1-.1.24.27.27,0,0,1-.27,0l-1.29-.75A.75.75,0,0,1,493.41,137.28Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M498.09,139.16a7.84,7.84,0,0,1-1.06-3.82l0-.45c0-1.46.34-2.43,1-2.89s1.59-.34,2.78.35a7.17,7.17,0,0,1,2.81,2.89,8.17,8.17,0,0,1,1,3.94v.37a.25.25,0,0,1-.1.24.29.29,0,0,1-.28,0l-5.09-2.94V137a4.55,4.55,0,0,0,.47,1.89,3,3,0,0,0,1.2,1.34,1.15,1.15,0,0,0,1.43,0,.38.38,0,0,1,.21-.12.68.68,0,0,1,.26.11l1.35.78a.71.71,0,0,1,.24.22.52.52,0,0,1,.1.31.93.93,0,0,1-.44.74,1.93,1.93,0,0,1-1.25.27,4.29,4.29,0,0,1-1.88-.67A7.42,7.42,0,0,1,498.09,139.16Zm4.4-1.9v0a4.06,4.06,0,0,0-.46-1.92A3.14,3.14,0,0,0,500.8,134c-.52-.3-.93-.33-1.23-.08a1.77,1.77,0,0,0-.44,1.4v0Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M547.49,157.24v2.42l2.75,1.58v-2.41Zm-.11,24.67,2.86,1.65v-2.42l-2.86-1.65Zm-28.82-35.74-9.32-5.36v2.42l9.32,5.36Zm26.55,17.69,3.28,1.9v-2.42l-3.28-1.89Zm-21.26-20.21-7.34-4.24v2.41l7.34,4.25Zm21.91,12.59-6.85-3.93v2.42l6.85,3.93Zm-8.58-4.93-11.6-6.66v2.41l11.6,6.67Zm-2.59,15.24-11.93-6.85v2.41L534.59,169Zm8.79-6.1L528,151.6V154l15.42,8.86Zm-15-3L521,153.18v2.42l7.35,4.24Zm-2.16-6.83-5.94-3.43v2.42l5.94,3.43ZM538.8,177l6.85,3.93v-2.42l-6.85-3.93Zm-2.48-7,8.83,5.08v-2.41l-8.83-5.08Zm-19.92-5.88,7.34,4.24V165.9l-7.34-4.24Zm13.72-3.24,7.6,4.36v-2.42l-7.6-4.36Zm9.33,5.35,10.79,6.21V170l-10.79-6.2Zm-18.51-7.49-6-3.43v2.42l6,3.43Zm-1.62-6.51-10.08-5.8v2.42l10.08,5.79Zm-11.91,6.72,7.26,4.17v-2.42l-7.26-4.16Zm18.06,10.4L537.08,176v-2.42l-11.61-6.66Zm-40.14-23.14,20.35,11.75V155.5l-20.35-11.75Zm29.45-7.76-5.54-3.18v2.42l5.54,3.18Zm-1.51,15.86-13.75-7.9v2.41l13.75,7.91ZM483.6,142.76l-10.38-6.12v2.42l10.38,6.11Zm14.2,2.61-14.31-8.26v2.42l14.31,8.25Zm-16-9.25-8.54-5.06v2.42l8.54,5.05Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M523.65,272a.47.47,0,0,1-.25-.07l-1.08-.65a.49.49,0,0,1-.17-.69.51.51,0,0,1,.68-.17l.81.49,1.18-.79a.5.5,0,0,1,.56.83c-.43.3-.92.62-1.45,1A.57.57,0,0,1,523.65,272ZM520,269.84a.59.59,0,0,1-.25-.07l-2.57-1.55a.51.51,0,0,1-.18-.69.52.52,0,0,1,.69-.17l2.57,1.55a.48.48,0,0,1,.17.68A.5.5,0,0,1,520,269.84Zm7.5-.57a.49.49,0,0,1-.39-.19.5.5,0,0,1,.08-.7q1.2-1,2.31-1.89a.49.49,0,0,1,.7.06.49.49,0,0,1-.06.7c-.74.63-1.52,1.27-2.33,1.91A.51.51,0,0,1,527.5,269.27Zm-12.64-2.53a.47.47,0,0,1-.25-.07L512,265.13a.51.51,0,0,1-.17-.69.5.5,0,0,1,.69-.17l2.57,1.55a.5.5,0,0,1-.26.92Zm17.23-1.34a.51.51,0,0,1-.38-.16.51.51,0,0,1,0-.71c.76-.68,1.49-1.35,2.19-2a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71c-.71.68-1.44,1.36-2.21,2A.5.5,0,0,1,532.09,265.4Zm-22.37-1.75a.48.48,0,0,1-.26-.07L506.89,262a.5.5,0,1,1,.52-.85l2.57,1.54a.5.5,0,0,1,.17.69A.49.49,0,0,1,509.72,263.65Zm26.69-2.4a.45.45,0,0,1-.34-.14.5.5,0,0,1,0-.71c.71-.73,1.38-1.45,2-2.18a.48.48,0,0,1,.7,0,.49.49,0,0,1,.05.7c-.66.74-1.34,1.48-2.06,2.22A.51.51,0,0,1,536.41,261.25Zm-31.83-.69a.48.48,0,0,1-.26-.07l-2.57-1.55a.5.5,0,0,1-.17-.69.52.52,0,0,1,.69-.17l2.57,1.55a.5.5,0,0,1-.26.93Zm-5.14-3.09a.59.59,0,0,1-.26-.07l-2.57-1.55a.5.5,0,0,1,.51-.86l2.58,1.55a.5.5,0,0,1,.17.68A.51.51,0,0,1,499.44,257.47Zm40.95-.71A.49.49,0,0,1,540,256c.63-.78,1.23-1.58,1.8-2.36a.5.5,0,0,1,.7-.12.51.51,0,0,1,.11.7c-.58.8-1.19,1.61-1.83,2.41A.51.51,0,0,1,540.39,256.76Zm-46.09-2.39a.48.48,0,0,1-.26-.07l-2.57-1.54a.5.5,0,0,1,.51-.86l2.57,1.55a.49.49,0,0,1-.25.92Zm49.58-2.47a.51.51,0,0,1-.42-.77c.54-.84,1-1.7,1.51-2.55a.5.5,0,0,1,.68-.2.51.51,0,0,1,.2.68c-.48.87-1,1.75-1.54,2.61A.51.51,0,0,1,543.88,251.9Zm-54.72-.62a.48.48,0,0,1-.26-.07l-2.57-1.55a.48.48,0,0,1-.17-.68.49.49,0,0,1,.68-.17l2.57,1.54a.5.5,0,0,1,.17.69A.48.48,0,0,1,489.16,251.28ZM484,248.19a.47.47,0,0,1-.25-.07l-2.58-1.55a.5.5,0,0,1,.52-.86l2.57,1.55a.5.5,0,0,1,.17.69A.51.51,0,0,1,484,248.19Zm62.76-1.54a.5.5,0,0,1-.21-.05.52.52,0,0,1-.25-.67c.42-.88.81-1.8,1.16-2.72a.5.5,0,1,1,.94.36c-.37.94-.77,1.88-1.19,2.79A.49.49,0,0,1,546.77,246.65Zm-67.9-1.55a.63.63,0,0,1-.26-.07L476,243.48a.51.51,0,0,1-.17-.69.5.5,0,0,1,.69-.17l2.57,1.55a.5.5,0,0,1-.26.93Zm-5.14-3.1a.48.48,0,0,1-.26-.07l-2.57-1.54a.51.51,0,0,1-.17-.69.5.5,0,0,1,.69-.17l2.57,1.55a.5.5,0,0,1,.17.68A.49.49,0,0,1,473.73,242Zm75.2-.95a.39.39,0,0,1-.15,0,.49.49,0,0,1-.33-.62c.29-.93.55-1.89.79-2.86a.5.5,0,0,1,1,.23c-.24,1-.51,2-.81,2.92A.48.48,0,0,1,548.93,241.05Zm-80.34-2.14a.48.48,0,0,1-.26-.07l-2.57-1.55a.49.49,0,0,1-.17-.68.5.5,0,0,1,.69-.17l2.57,1.54a.51.51,0,0,1,.17.69A.5.5,0,0,1,468.59,238.91Zm-5.14-3.09a.59.59,0,0,1-.26-.07l-2.57-1.55a.5.5,0,0,1-.17-.69.51.51,0,0,1,.68-.17l2.58,1.55a.51.51,0,0,1,.17.69A.52.52,0,0,1,463.45,235.82Zm86.89-.59h-.09a.5.5,0,0,1-.4-.58c.17-.94.33-1.93.46-2.94a.5.5,0,0,1,1,.13c-.13,1-.29,2-.46,3A.51.51,0,0,1,550.34,235.23Zm-92-2.5a.59.59,0,0,1-.26-.07l-2.57-1.55a.5.5,0,0,1,.51-.86l2.57,1.55a.48.48,0,0,1,.17.68A.49.49,0,0,1,458.31,232.73Zm-5.15-3.1a.47.47,0,0,1-.25-.07L450.33,228a.51.51,0,0,1-.17-.69.51.51,0,0,1,.69-.17l2.57,1.55a.5.5,0,0,1-.26.92Zm98-.34h0a.5.5,0,0,1-.46-.51l-2.33-1.34a.5.5,0,1,1,.5-.86l2.6,1.49a.49.49,0,0,1,.25.48l0,.28A.51.51,0,0,1,551.13,229.29ZM448,226.54a.51.51,0,0,1-.26-.07l-2.57-1.55a.5.5,0,1,1,.52-.85l2.57,1.54a.5.5,0,0,1,.17.69A.49.49,0,0,1,448,226.54ZM546,226a.57.57,0,0,1-.25-.06l-2.6-1.5a.5.5,0,0,1,.5-.87l2.6,1.5a.51.51,0,0,1,.19.68A.52.52,0,0,1,546,226Zm-99.28-2.91a.51.51,0,0,1-.37-.17.49.49,0,0,1,0-.7c.75-.68,1.48-1.36,2.19-2a.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71c-.72.68-1.45,1.37-2.21,2.05A.5.5,0,0,1,446.67,223.1Zm94.08-.08a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.49a.52.52,0,0,1,.19.69A.52.52,0,0,1,540.75,223Zm-5.2-3a.57.57,0,0,1-.25-.06l-2.6-1.5a.49.49,0,0,1-.18-.68.51.51,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.19.68A.51.51,0,0,1,535.55,220ZM451,219a.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71c.71-.72,1.39-1.43,2.06-2.15a.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71c-.67.72-1.37,1.45-2.08,2.18A.51.51,0,0,1,451,219ZM530.35,217a.47.47,0,0,1-.25-.07l-2.6-1.49a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1,.19.68A.51.51,0,0,1,530.35,217Zm-75.27-2.48a.52.52,0,0,1-.33-.12.51.51,0,0,1-.05-.71c.66-.76,1.29-1.52,1.9-2.29a.52.52,0,0,1,.71-.08.5.5,0,0,1,.08.7c-.62.78-1.26,1.55-1.93,2.33A.52.52,0,0,1,455.08,214.55Zm70.07-.51a.59.59,0,0,1-.25-.07l-2.6-1.5a.5.5,0,1,1,.5-.86l2.6,1.49a.52.52,0,0,1,.19.69A.51.51,0,0,1,525.15,214Zm-5.2-3a.5.5,0,0,1-.24-.06l-2.61-1.5a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.6,1.5a.5.5,0,0,1,.19.68A.51.51,0,0,1,520,211Zm-61.13-1.18a.53.53,0,0,1-.3-.09.5.5,0,0,1-.1-.7c.59-.81,1.16-1.63,1.71-2.44a.5.5,0,0,1,.69-.14.51.51,0,0,1,.14.7c-.56.82-1.13,1.65-1.74,2.47A.51.51,0,0,1,458.82,209.86Zm55.93-1.81a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1-.18-.68.49.49,0,0,1,.68-.18l2.6,1.49a.5.5,0,0,1-.25.94Zm-5.2-3a.57.57,0,0,1-.25-.06l-2.59-1.5a.5.5,0,0,1-.19-.68.51.51,0,0,1,.69-.19l2.59,1.5a.5.5,0,0,1-.25.93Zm-47.39-.17a.48.48,0,0,1-.26-.07.5.5,0,0,1-.17-.69c.52-.85,1-1.72,1.48-2.58a.5.5,0,0,1,.88.48c-.47.88-1,1.76-1.51,2.62A.48.48,0,0,1,462.16,204.88Zm42.19-2.82a.42.42,0,0,1-.24-.07l-2.6-1.49a.51.51,0,0,1-.19-.69.5.5,0,0,1,.68-.18l2.6,1.5a.49.49,0,0,1,.19.68A.5.5,0,0,1,504.35,202.06ZM465,199.62a.54.54,0,0,1-.22-.05.5.5,0,0,1-.23-.67c.43-.89.84-1.8,1.23-2.71a.5.5,0,0,1,.92.4c-.39.92-.81,1.84-1.25,2.75A.52.52,0,0,1,465,199.62Zm34.13-.55a.52.52,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1-.19-.68.51.51,0,0,1,.69-.18l2.6,1.49a.51.51,0,0,1,.18.69A.5.5,0,0,1,499.16,199.07Zm-5.2-3a.45.45,0,0,1-.25-.07l-2.6-1.49a.5.5,0,1,1,.49-.87l2.61,1.5a.5.5,0,0,1,.18.68A.5.5,0,0,1,494,196.07Zm-26.58-2-.17,0a.5.5,0,0,1-.3-.64c.34-.92.67-1.86,1-2.81a.5.5,0,0,1,1,.3c-.31,1-.64,1.93-1,2.86A.49.49,0,0,1,467.38,194.1Zm21.38-1a.43.43,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.19-.68.51.51,0,0,1,.69-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-5.2-3a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.19-.68.52.52,0,0,1,.69-.19l2.6,1.5a.5.5,0,0,1-.25.93Zm-14.35-1.69h-.13a.51.51,0,0,1-.35-.62c.26-.95.49-1.92.71-2.89a.5.5,0,0,1,1,.22c-.22,1-.47,2-.73,2.93A.49.49,0,0,1,469.21,188.39Zm9.15-1.3a.45.45,0,0,1-.25-.07l-2.6-1.49a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-5.2-3a.55.55,0,0,1-.25-.07l-2.6-1.5a.5.5,0,1,1,.5-.86l2.6,1.49a.51.51,0,0,1,.18.69A.5.5,0,0,1,473.16,184.1Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M408.75,273.21a.59.59,0,0,1-.25-.07l-2.59-1.5a.51.51,0,0,1-.19-.68.52.52,0,0,1,.69-.19l2.34,1.36,1.21-.7a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-1.46.84A.52.52,0,0,1,408.75,273.21Zm4.06-2.34a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l2.59-1.5a.5.5,0,1,1,.5.86l-2.59,1.5A.47.47,0,0,1,412.81,270.87Zm-9.25-.66a.55.55,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.87l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,403.56,270.21ZM418,267.87a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.49.49,0,0,1-.18.68l-2.6,1.5A.45.45,0,0,1,418,267.87Zm-19.64-.66a.59.59,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1-.18-.68.51.51,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,398.36,267.21Zm24.84-2.34a.52.52,0,0,1-.44-.25.5.5,0,0,1,.19-.68l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.47.47,0,0,1,423.2,264.87Zm-30-.66a.55.55,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,393.17,264.21Zm35.22-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.45.45,0,0,1,428.39,261.87ZM388,261.21a.59.59,0,0,1-.25-.07l-1.73-1a.5.5,0,0,1,0-.87l.86-.5a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-.11.07,1,.56a.51.51,0,0,1,.18.69A.5.5,0,0,1,388,261.21Zm40.7-2.34a.47.47,0,0,1-.25-.07l-2.59-1.5a.5.5,0,0,1-.19-.68.51.51,0,0,1,.69-.18l2.59,1.5a.49.49,0,0,1,.19.68A.51.51,0,0,1,428.67,258.87Zm-39-.66a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.6-1.5a.5.5,0,0,1,.5.87l-2.6,1.5A.55.55,0,0,1,389.7,258.21Zm33.78-2.34a.45.45,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm-28.58-.66a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.6-1.5a.5.5,0,0,1,.5.87l-2.6,1.5A.59.59,0,0,1,394.9,255.21Zm23.38-2.34a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm-18.19-.66a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.6-1.5a.5.5,0,1,1,.5.87l-2.6,1.5A.52.52,0,0,1,400.09,252.21Zm13-2.34a.47.47,0,0,1-.25-.07l-2.59-1.5a.5.5,0,1,1,.5-.86l2.59,1.5a.49.49,0,0,1,.19.68A.5.5,0,0,1,413.08,249.87Zm-7.79-.66a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.6-1.5a.5.5,0,0,1,.5.87l-2.6,1.5A.55.55,0,0,1,405.29,249.21Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M442.16,318.87a.43.43,0,0,1-.25-.07l-2.6-1.5a.5.5,0,1,1,.5-.86l2.6,1.5a.5.5,0,0,1,.18.68A.5.5,0,0,1,442.16,318.87Zm2.32-1.33a.5.5,0,0,1-.24-.93l2.6-1.49a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.61,1.49A.54.54,0,0,1,444.48,317.54ZM437,315.87a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm12.73-1.31a.5.5,0,0,1-.24-.93l2.6-1.49a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-2.61,1.49A.54.54,0,0,1,449.69,314.56Zm-17.93-1.69a.57.57,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.5.5,0,0,1,.68-.18l2.6,1.5a.51.51,0,0,1,.19.68A.52.52,0,0,1,431.76,312.87Zm23.14-1.28a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.61-1.48a.49.49,0,0,1,.68.18.49.49,0,0,1-.19.68l-2.6,1.49A.45.45,0,0,1,454.9,311.59Zm-28.33-1.72a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.5.5,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm32.63-1.26a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.74a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93ZM454,305.61a.47.47,0,0,1-.25-.07l-2.59-1.5a.49.49,0,0,1-.19-.68.5.5,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1,.19.68A.51.51,0,0,1,454,305.61Zm-37.83-1.73a.59.59,0,0,1-.25-.07l-2.59-1.5a.51.51,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1-.25.94Zm32.64-1.27a.45.45,0,0,1-.25-.07L446,301a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93ZM411,300.88a.55.55,0,0,1-.25-.07l-2.6-1.5a.51.51,0,0,1-.18-.69.5.5,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1,.18.68A.49.49,0,0,1,411,300.88Zm32.63-1.27a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.59.59,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.18-.68.51.51,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,405.78,297.88Zm32.63-1.27a.47.47,0,0,1-.25-.07l-2.59-1.5a.49.49,0,0,1-.19-.68.51.51,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1,.19.68A.51.51,0,0,1,438.41,296.61Zm-37.83-1.73a.59.59,0,0,1-.25-.07l-2.59-1.5a.5.5,0,0,1-.19-.68.52.52,0,0,1,.69-.19l2.59,1.5a.5.5,0,0,1-.25.94Zm32.64-1.27a.45.45,0,0,1-.25-.07l-2.6-1.49a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.45.45,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,395.39,291.88ZM428,290.61a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.47.47,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.18-.68.51.51,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,390.19,288.88Zm32.63-1.27a.47.47,0,0,1-.25-.07L420,286.05a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1-.25.93ZM385,285.88a.47.47,0,0,1-.25-.07l-2.59-1.5a.5.5,0,1,1,.5-.86l2.59,1.5a.49.49,0,0,1,.19.68A.51.51,0,0,1,385,285.88Zm32.64-1.27a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.45.45,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm32.63-1.27a.57.57,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm32.64-1.27a.51.51,0,0,1-.25-.06l-2.6-1.5a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.6,1.5a.5.5,0,0,1,.18.68A.5.5,0,0,1,407.24,278.61Zm-37.83-1.73a.43.43,0,0,1-.25-.07l-2.6-1.5a.5.5,0,1,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93ZM402,275.61a.54.54,0,0,1-.25-.06l-2.6-1.5a.5.5,0,0,1,.5-.87l2.6,1.5a.5.5,0,0,1-.25.93Zm-37.83-1.73a.45.45,0,0,1-.25-.07l-.59-.34a.5.5,0,0,1,0-.87l2-1.15a.51.51,0,0,1,.68.19.49.49,0,0,1-.19.68l-1.28.74a.5.5,0,0,1-.38.82Zm32.63-1.26a.59.59,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.87l2.6,1.5a.52.52,0,0,1,.19.69A.52.52,0,0,1,396.84,272.62Zm-28.61-1.72a.52.52,0,0,1-.44-.25A.5.5,0,0,1,368,270l2.61-1.49a.5.5,0,0,1,.68.18.51.51,0,0,1-.19.69l-2.6,1.48A.47.47,0,0,1,368.23,270.9Zm23.42-1.28a.52.52,0,0,1-.25-.07l-2.6-1.5a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,391.65,269.62Zm-18.21-1.7a.5.5,0,0,1-.25-.93l2.61-1.49a.5.5,0,1,1,.49.87l-2.6,1.49A.57.57,0,0,1,373.44,267.92Zm13-1.3a.55.55,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.87l2.6,1.5a.51.51,0,0,1,.18.69A.5.5,0,0,1,386.45,266.62Zm-7.8-1.67a.51.51,0,0,1-.44-.26.51.51,0,0,1,.19-.68l2.47-1.41a.5.5,0,0,1,.49,0l.14.08a.52.52,0,0,1,.19.69.52.52,0,0,1-.56.23l-2.23,1.28A.59.59,0,0,1,378.65,265Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M437.25,289.87a.47.47,0,0,1-.25-.07l-2.59-1.5a.5.5,0,1,1,.5-.86l2.34,1.35,1.21-.69a.5.5,0,0,1,.68.18.51.51,0,0,1-.18.69l-1.46.83A.43.43,0,0,1,437.25,289.87Zm4.06-2.34a.5.5,0,0,1-.25-.93l2.59-1.5a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-2.59,1.5A.57.57,0,0,1,441.31,287.53Zm-9.25-.66a.45.45,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm14.44-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.54.54,0,0,1,446.5,284.53Zm-19.64-.66a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm24.84-2.34a.52.52,0,0,1-.44-.25.51.51,0,0,1,.19-.68l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.57.57,0,0,1,451.7,281.53Zm-30-.66a.45.45,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm35.22-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.54.54,0,0,1,456.89,278.53Zm-40.42-.66a.47.47,0,0,1-.25-.07l-1.73-1a.47.47,0,0,1-.25-.43.48.48,0,0,1,.25-.43l.86-.5a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-.11.07,1,.57a.5.5,0,0,1-.25.93Zm40.7-2.34a.57.57,0,0,1-.25-.06l-2.59-1.5a.5.5,0,1,1,.5-.87l2.59,1.5a.5.5,0,0,1,.19.68A.51.51,0,0,1,457.17,275.53Zm-39-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.45.45,0,0,1,418.2,274.87ZM452,272.53a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-28.58-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.47.47,0,0,1,423.4,271.87Zm23.38-2.34a.57.57,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-18.19-.66a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.43.43,0,0,1,428.59,268.87Zm13-2.34a.57.57,0,0,1-.25-.06l-2.59-1.5a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18l2.59,1.5a.5.5,0,0,1-.25.93Zm-7.79-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.45.45,0,0,1,433.79,265.87Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M464.92,305.87a.47.47,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.35,1.35,1.2-.69a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-1.45.83A.45.45,0,0,1,464.92,305.87Zm4.05-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.54.54,0,0,1,469,303.53Zm-9.24-.66a.43.43,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1,.18.68A.5.5,0,0,1,459.73,302.87Zm14.44-2.34a.52.52,0,0,1-.44-.25.51.51,0,0,1,.19-.68l2.59-1.5a.5.5,0,1,1,.5.87l-2.59,1.5A.57.57,0,0,1,474.17,300.53Zm-19.64-.66a.45.45,0,0,1-.25-.07l-2.6-1.5a.5.5,0,0,1,.5-.86l2.6,1.5a.5.5,0,0,1-.25.93Zm24.83-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.54.54,0,0,1,479.36,297.53Zm-30-.66a.47.47,0,0,1-.25-.07l-2.59-1.5a.49.49,0,0,1-.19-.68.51.51,0,0,1,.69-.18l2.59,1.5a.51.51,0,0,1,.19.68A.52.52,0,0,1,449.33,296.87Zm35.23-2.34a.5.5,0,0,1-.25-.93l2.6-1.5a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-2.6,1.5A.57.57,0,0,1,484.56,294.53Zm-40.42-.66a.45.45,0,0,1-.25-.07l-1.73-1a.47.47,0,0,1-.25-.43.48.48,0,0,1,.25-.43l.86-.5a.5.5,0,1,1,.5.86l-.11.07,1,.57a.5.5,0,0,1-.25.93Zm40.7-2.34a.57.57,0,0,1-.25-.06L482,290a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-39-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,0,1,.5.86l-2.6,1.5A.47.47,0,0,1,445.87,290.87Zm33.77-2.34a.57.57,0,0,1-.25-.06L476.8,287a.5.5,0,1,1,.5-.87l2.59,1.5a.5.5,0,0,1-.25.93Zm-28.57-.66a.5.5,0,0,1-.25-.93l2.59-1.5a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-2.59,1.5A.47.47,0,0,1,451.07,287.87Zm23.38-2.34a.54.54,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-18.19-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.45.45,0,0,1,456.26,284.87Zm13-2.34a.57.57,0,0,1-.25-.06l-2.6-1.5a.51.51,0,0,1-.18-.69.5.5,0,0,1,.68-.18l2.6,1.5a.5.5,0,0,1-.25.93Zm-7.79-.66a.5.5,0,0,1-.25-.93l2.6-1.5a.5.5,0,1,1,.5.86l-2.6,1.5A.47.47,0,0,1,461.46,281.87Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M490.6,230.45l13.81,1.67-6.4-12.8A60,60,0,0,1,490.6,230.45Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M453.72,265.48l2.51-1.45-5.06-2.92-2.51,1.46Zm21.08,3.06-28.35-16.37-2.52,1.45L472.29,270Zm-9.77-9,2.51-1.45-9-5.21L456,254.37Zm13.86-1.12-20.32-11.73-2.51,1.45,20.32,11.73Zm-52.71-8.88,20.31,11.73,2.52-1.45-20.32-11.73Zm7.33-8.2,20.32,11.73,2.51-1.45L436,239.93ZM494.58,280,477,269.79l-2.51,1.45,17.61,10.17Zm10.1-12.82-28.35-16.38-2.52,1.46,28.36,16.37Zm-30.52-17.63-20.32-11.73-2.51,1.45L471.65,251Zm6.9,10.2-2.52,1.45,5.06,2.92,2.51-1.45Zm-.17,18.56-22.49-13-2.51,1.45,22.48,13ZM467.2,260.83l17.16,9.91,2.51-1.45-17.16-9.91ZM486.52,272l18.37,10.6,2.51-1.45L489,270.54Zm7.71,10.67,5.27,3,2.51-1.45-5.26-3Zm-67.71-35.78-9-5.2L415,243.13l9,5.2Zm80.33,21.51-2.51,1.45,11.31,6.53,2.52-1.45Zm3.92,8.48-22.49-13-2.51,1.45,22.48,13Zm-59.1-40.34-12.61-7.28-2.51,1.45L449.16,238Zm-7.39,14.38-21.37-12.33L420.39,240l21.37,12.34Zm-10.42-12.23-5.57-3.21-2.51,1.45,5.57,3.21Zm22.54,6.8-22.73-13.12-2.51,1.45,22.73,13.12Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M430.78,332.51a.59.59,0,0,1-.25-.07l-.85-.5a.5.5,0,0,1,.5-.86l.61.35A25,25,0,0,0,433,330a.5.5,0,0,1,.59.81,25.26,25.26,0,0,1-2.57,1.65A.55.55,0,0,1,430.78,332.51Zm-3.44-2a.55.55,0,0,1-.25-.07l-2.59-1.51a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.59,1.51a.51.51,0,0,1,.18.69A.5.5,0,0,1,427.34,330.5Zm8.21-1.59a.55.55,0,0,1-.34-.13.51.51,0,0,1,0-.71c.64-.7,1.3-1.56,1.86-2.3a.51.51,0,0,1,.7-.1.52.52,0,0,1,.1.71c-.58.75-1.25,1.63-1.92,2.36A.5.5,0,0,1,435.55,328.91Zm-13.39-1.44a.48.48,0,0,1-.26-.07l-2.59-1.51a.5.5,0,1,1,.51-.86l2.59,1.51a.5.5,0,0,1-.25.93Zm-5.19-3a.59.59,0,0,1-.25-.07l-2.59-1.51a.5.5,0,0,1,.51-.87l2.59,1.51a.5.5,0,0,1-.26.94Zm22.23-.27a.42.42,0,0,1-.24-.07l-2.61-1.48a.5.5,0,1,1,.5-.87l2.6,1.48a.52.52,0,0,1,.19.69A.51.51,0,0,1,439.2,324.18Zm-27.41-2.76a.47.47,0,0,1-.25-.07L409,319.84a.5.5,0,0,1,.5-.86l2.59,1.51a.5.5,0,0,1-.25.93Zm22.2-.21a.59.59,0,0,1-.25-.07l-2.6-1.49a.5.5,0,1,1,.49-.87l2.61,1.49a.51.51,0,0,1,.19.68A.5.5,0,0,1,434,321.21Zm-27.38-2.81a.47.47,0,0,1-.25-.07l-2.59-1.51a.51.51,0,0,1-.18-.69.5.5,0,0,1,.68-.18l2.59,1.52a.5.5,0,0,1-.25.93Zm22.17-.17a.57.57,0,0,1-.25-.06l-2.6-1.49a.5.5,0,0,1-.19-.68.51.51,0,0,1,.68-.19L429,317.3a.5.5,0,0,1,.19.68A.52.52,0,0,1,428.78,318.23Zm-27.35-2.86a.45.45,0,0,1-.25-.07l-2.59-1.51a.5.5,0,1,1,.5-.86l2.59,1.51a.5.5,0,0,1-.25.93Zm22.14-.11a.45.45,0,0,1-.25-.07l-2.6-1.48a.51.51,0,0,1-.19-.69.49.49,0,0,1,.68-.18l2.61,1.48a.51.51,0,0,1,.18.69A.5.5,0,0,1,423.57,315.26Zm-27.32-2.91a.43.43,0,0,1-.25-.07l-2.6-1.51a.51.51,0,0,1-.18-.69.51.51,0,0,1,.69-.18l2.59,1.52a.5.5,0,0,1-.25.93Zm22.11-.06a.55.55,0,0,1-.25-.07l-2.61-1.49a.5.5,0,0,1,.5-.87l2.61,1.49a.49.49,0,0,1,.18.68A.51.51,0,0,1,418.36,312.29Zm-27.29-3a.48.48,0,0,1-.26-.07l-2.3-1.34a.5.5,0,0,1-.25-.43.52.52,0,0,1,.25-.43l.28-.17a.5.5,0,0,1,.69.17.49.49,0,0,1,.07.31l1.77,1a.51.51,0,0,1,.18.69A.52.52,0,0,1,391.07,309.32Zm22.08,0a.54.54,0,0,1-.25-.06l-2.61-1.49a.5.5,0,0,1,.5-.87l2.6,1.49a.5.5,0,0,1-.24.93Zm-5.21-3a.45.45,0,0,1-.25-.07l-2.61-1.48a.51.51,0,0,1-.18-.69.49.49,0,0,1,.68-.18l2.6,1.48a.51.51,0,0,1,.19.69A.5.5,0,0,1,407.94,306.34Zm-16.43-.24a.52.52,0,0,1-.39-.19.49.49,0,0,1,.08-.7l.42-.35a14.32,14.32,0,0,0,1.63-1.7.5.5,0,0,1,.77.64,14.8,14.8,0,0,1-1.75,1.82l-.45.37A.51.51,0,0,1,391.51,306.1Zm11.21-2.74a.5.5,0,0,1-.24-.06l-2.61-1.49a.5.5,0,0,1-.19-.68.52.52,0,0,1,.69-.19l2.6,1.49a.5.5,0,0,1-.25.93Zm-7.25-1.75a.55.55,0,0,1-.3-.09.5.5,0,0,1-.1-.7l.3-.41.95-1.27A.51.51,0,0,1,397,299l.79.46a.5.5,0,0,1,.19.68.52.52,0,0,1-.69.19l-.4-.24-.66.88-.33.44A.49.49,0,0,1,395.47,301.61Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "93.02 197.19 90.13 193.99 47.19 170.99 48.01 170.08 43.99 167.18 42.55 171.41 42.14 173.94 93.02 197.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M415.72,256.19h0a3.47,3.47,0,0,1-4.71,1.42L364.84,233s2.87-2.46,2.9-2.44Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M415.1,256.81l-48-25.69s-1.37,1.13-2.22,1.86l-.06,0s2.87-2.46,2.9-2.44l48,25.68a3.52,3.52,0,0,1-.94,1.11A3.45,3.45,0,0,0,415.1,256.81Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M474.59,278.75c1.31.71,5.42,1.73,6.13.41s-2.25-4.47-3.56-5.18a2.71,2.71,0,1,0-2.57,4.77Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M451.29,273.75c-7-3.66,2.35-21.61,10-17.21s16,15.84,16,15.84h0c1,1.18,1.21,2.7.15,4.65s-1.94,2.51-4,2.43h0S458.26,277.42,451.29,273.75Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M456.39,261c-6.19-4.87-3.37-8.94,3.49-3.44s16,14.61,16,14.61l0,0c1.06,1,1.57,1.8,1.23,2.22s-.88.28-2.44-.68l0,0S462.58,265.9,456.39,261Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M453.54,273.43c-6.47-1.93-5.88-4.83,1.33-2.62S472.35,277,472.35,277h0c1.17.44,1.85.83,1.76,1.14s-.56.31-2.1,0h0S460,275.37,453.54,273.43Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M434,264.7l9.54-17.7,17.83,9.52h0l.07,0c2.84,1.54,3,6.74.38,11.63s-7.07,7.6-9.92,6.07l-.07,0h0Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M434.06,264.72c2.85,1.53,7.29-1.19,9.92-6.07s2.46-10.1-.38-11.63-7.29,1.19-9.92,6.07S431.21,263.18,434.06,264.72Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M369,229.74l9.54-17.69,65.2,35.13h0l.07,0c2.84,1.53,3,6.73.38,11.62s-7.07,7.6-9.92,6.07l-.07,0h0Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M369,229.76c2.85,1.53,7.29-1.18,9.92-6.07s2.46-10.09-.38-11.63-7.29,1.19-9.92,6.08S366.14,228.23,369,229.76Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M378.5,223.61c2.63-4.89,2.46-10.09-.39-11.63l-.19-.08a3.44,3.44,0,0,1,.93.33c2.85,1.53,3,6.74.39,11.62s-6.87,7.48-9.72,6.16C372.33,230.61,376.14,228,378.5,223.61Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M358.55,222.09l8.09-15,10.12,5.61h0l.06,0c2.41,1.3,2.56,5.72.33,9.86s-6,6.46-8.42,5.16l-.06,0h0Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M358.58,222.1c2.41,1.31,6.18-1,8.41-5.15s2.09-8.56-.32-9.86-6.19,1-8.42,5.15S356.16,220.8,358.58,222.1Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M366.66,216.79c2-3.78,2.09-7.77.26-9.44l.16.07c2.41,1.3,2.56,5.72.32,9.86s-6,6.46-8.41,5.15a2.75,2.75,0,0,1-.59-.42C360.82,223.13,364.48,220.85,366.66,216.79Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M385.26,216.22l75.5,41a7.41,7.41,0,0,1,.85.63c7.34,4.76,15.65,14.53,15.65,14.53h0c1,1.18,1.21,2.7.15,4.65s-1.94,2.51-4,2.43h0s-12.71-1.71-20.21-4.81a3.6,3.6,0,0,1-1.32-.39l-.07,0h0l-76-40.71Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M441.93,299.47l29.71-17.72s.25-.14.35-.18a50,50,0,0,1,6.86-2.91h0c.47-.16.24,1.45-.44,2.05h0s-4.4,3.64-7.24,5.52a2.92,2.92,0,0,1-.48.35l0,0h0l-29.82,17.9Z",
    transform: "translate(-322.7 -59.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 402.4,
    cy: 230.83,
    rx: 3.11,
    ry: 23.92,
    transform: "translate(-311.75 420.75) rotate(-62.29)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecEditor);
export default __webpack_public_path__ + "static/media/rec-editor.c74a3d27ae0340157abb2de8be89b205.svg";
export { ForwardRef as ReactComponent };